import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation UpdateUserReferrerSource($referrerSource: String, $referrerOtherSource: String) {
    updateUserReferrerSource(
      referrerSource: $referrerSource
      referrerOtherSource: $referrerOtherSource
    ) {
      id
    }
  }
`;

export const updateUserReferrerSource = (referrerSource, referrerOtherSource) =>
  executeGqlMutation({
    mutation: MUTATION,
    variables: { referrerSource, referrerOtherSource },
  }).then(({ data }) => getSingleProp(data));
